export const experience = [
  {
    month: "1.3 Year",
    year: "2021",
    title: "FE",
    company: 'Preqin',
    location: 'Banglore',
    description: [
      {
        project: "Preqin Pro",
        projectBrief: "",
        responsibility: [
          "•	Developing the features in fin. tech company ",
        ],
        role: "Front end developer",
        techStack: "React, Redux, JavaScript(ES6), Ajax, JSON"
      },
    ]
  },
  {
    month: "1.3 Year",
    year: "2020",
    title: "SSE",
    company: 'Sonata Software',
    location: 'Banglore',
    description: [
      {
        project: "TUI Library and Performance",
        projectBrief: "",
        responsibility: [
          "•	Developing the UI Library for all TUI brands ",
          "•	Implemented Re-usable React components, which can be used by developers across brands",
          "•	Finding and improving performance issues of the sites, using tools like Dynatrace, Webpagetest, lighthouse, Chrome Audit, Treo",
          "•	Analyzing chrome audits and performance flame charts and improving the code"
        ],
        role: "Web developer",
        techStack: "React, Redux, JavaScript(ES6), Ajax, JSON"
      },
      {
        project: "Webpage Perf Tool",
        projectBrief:
          "is a web application tool to compare trends and budgets of the performance of webpages of TUI brands and allows user to set KPI for each performance metrics.",
        responsibility: [
          "•	Engage in requirement specification process",
          "•	Developed a tool from scratch to measure performance of each pages",
          "•	Developed script to capture business flow and for time series configured influx dB to store metrics",
          "•	Setup of webpagetest private instance and test agents in GCP and AWS to run script and store data on private instance",
          "•	Implemented Visualization modules to show trend of page performance, budgets of all TUI brands using React charts and also developed a module to set KPI for each metrics"
        ],
        role: "Web developer",
        techStack:
          "React, Redux, Web pack, Nodejs, Influx dB, React Charts, AWS, HTML5, CSS3, JavaScript(ES6), Ajax, JSON"
      }
    ]
  },
  {
    month: "1 Year",
    year: "2018",
    title: "Associate Consultant",
    company: 'Capgemini',
    location: 'Banglore',
    description: [
      {
        project: "PerfTrack",
        projectBrief:
          "is a Performance test management web application for standardizing and orchestrating the end to end performance testing process. This web tool acts as a repository for project management and resource management.",
        responsibility: [
          "•	Implemented UI design for Dashboard by calculating overall highlights of test results and resource utilization. ",
          "•	Implemented Jenkins Module integration with Performance testing tool and HP Performance center which allows the performance tester to perform RUN, STOP and Download test report on Perftrack interface. ",
          "•	Redesigned UI for Visualizations by fetching metrics from Database.",
          "•	Generating Reports.",
          "•	Collect feedback from design and technical staff on Website development needs",
          "•	Create conceptual diagrams, visual mock-ups, and manage detailed user interface specifications"
        ],
        role: "Web developer",
        techStack:
          "HTML5,CSS3, React, Redux, JavaScript(ES6), Ajax, JSON, XML , FLOTJS, D3JS, Java, Spring, Jenkins, MySQL"
      }
    ]
  },
  {
    month: "1 Year",
    year: "2017",
    title: "SSE",
    company: 'Capgemini',
    location: 'Banglore',
    description: [
      {
        project: "Performance Analytics",
        projectBrief:
          "is a web application tool to compare and analyze different execution results generated by Load runner, JMeter or HP performance center.",
        responsibility: [
          "•	Engage in requirement specification process",
          "•	Implemented Responsive UI Design",
          "•	Implemented Visualization modules by configuring ELK setup and fetching, Modifying Data for business need ",
          "•	Increased performance of DOM operation by replacing SVG graphs with Canvas using FLOTJS library.",
          "•	Generating Reports."
        ],
        role: "Web developer",
        techStack:
          "HTML5, CSS3, JavaScript(ES6), Ajax, JSON, XML ,React, Redux, Java, Spring, Kafaka, Logstash, Elastic search, MySQL"
      }
    ]
  },
  {
    month: "1.2 Year",
    year: "2016",
    title: "SE",
    company: 'Capgemini',
    location: 'Banglore',
    description: [
      {
        project:
          "Performance Testing tool and Auto Prediction tool development/ Web Application",
        projectBrief: "",
        responsibility: [
          "•	Engage in requirement specification process",
          "•	Design Web UI.",
          "•	Design Graphical representation and live graphs.",
          "•	Implementing Algorithms to identify top business work flows and showing them with visual effects using flotjs, d3js and familiar JavaScript libraries. ",
          "•	Support in backend and database implementation.",
          "•	Integration.",
          "•	Configure web-server and app-server."
        ],
        role: "Web developer",
        techStack:
          "HTML5, CSS3, JavaScript(ES6), Ajax, JSON, XML, Java, Spring, Kafaka, Logstash, Elastic search, MySQL"
      }
    ]
  }
];
